import '../../index.css';
var styles = {
  "content": "bp_dropdown_menu_module_content--8449d",
  "fullScreenContent": "bp_dropdown_menu_module_fullScreenContent--8449d",
  "ellipsis": "bp_dropdown_menu_module_ellipsis--8449d",
  "checkmark": "bp_dropdown_menu_module_checkmark--8449d",
  "item": "bp_dropdown_menu_module_item--8449d",
  "subMenuTrigger": "bp_dropdown_menu_module_subMenuTrigger--8449d",
  "radioItem": "bp_dropdown_menu_module_radioItem--8449d",
  "checkboxItem": "bp_dropdown_menu_module_checkboxItem--8449d",
  "dropdownMenuItemSeparator": "bp_dropdown_menu_module_dropdownMenuItemSeparator--8449d",
  "menuHeader": "bp_dropdown_menu_module_menuHeader--8449d",
  "headerTextContent": "bp_dropdown_menu_module_headerTextContent--8449d",
  "submenuCloseButton": "bp_dropdown_menu_module_submenuCloseButton--8449d",
  "menuCloseButton": "bp_dropdown_menu_module_menuCloseButton--8449d"
};
export { styles as default };